import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import Modal from '../../../../../UIelements/Modal';
import * as Styled from '../styles';
import { authenticationPassword } from '../../../../../../services';
import { toast } from 'react-toastify';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../../../../../../db/db';
import Loading from '../../../../../Loading';
import z from 'zod';
import { useForm } from 'react-hook-form';
import { Button, Input } from '@praticabr/ppsa';

type ManualError = {
    type: "manual";
    message: string;
};

const createError = (message: string): ManualError => ({
    type: "manual",
    message
});

type ModalProps = {
    user: any;
    onCancel: () => void;
    onChangePage: (page: string) => void;
    onChangeEmailFieldEnabled: (enabled: boolean) => void;
    onPasswordConfirmed: (password: string) => void;
}

const InformPasswordFormSchema = z.object({
    currentPassword: z.string().min(6, 'user.Preencha a senha atual').nonempty('user.Preencha a senha atual').trim(),
});

type FormDataInformPassword = z.infer<typeof InformPasswordFormSchema>;

export const ModalInformPassword: React.FC<ModalProps> = (props) => {
    const intl = useIntl();
    const userDb = useLiveQuery(() => db.user.toArray());
    const [isLoading, setIsLoading] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm<FormDataInformPassword>()

    const submitInformPassword = (data: FormDataInformPassword) => {
        try {
            const userInfo = {
                email: props.user.email,
                password: data.currentPassword
            }
            if (userDb?.[0]) {
                setIsLoading(true);
                authenticationPassword(userInfo, userDb[0].accessToken)
                    .then(() => {
                        props.onPasswordConfirmed(data.currentPassword);
                        props.onChangeEmailFieldEnabled(true);
                        props.onChangePage("EditAccount");
                        setIsLoading(false)
                    })
                    .catch(() => {
                        toast.error(intl.formatMessage({ id: 'main.Informe sua senha atual corretamente' }).toUpperCase());
                        setIsLoading(false)
                    })
            }
        } catch (error) {
            toast.error(intl.formatMessage({ id: 'menus.Existem campos com informações inválidas' }).toUpperCase());
            setIsLoading(false)
        }
    };

    const footerInformPassword = (
        <>
            <Button type='button' size='lg' variant='confirmation-modal' width='108px' onClick={handleSubmit(submitInformPassword)} >
                {intl.formatMessage({ id: 'main.CONFIRMAR' })}
            </Button>
            <Button type='button' size='lg' variant='cancellation' width='108px' onClick={() => props.onChangePage("EditAccount")} >
                {intl.formatMessage({ id: 'menus.CANCELAR' })}
            </Button>
        </>
    );


    return (
        <Modal
            title={intl.formatMessage({ id: 'main.INFORME SUA SENHA' })}
            onCancel={props.onCancel}
            footer={footerInformPassword}
            width='380px'
        >
            {isLoading && <Loading />}
            {!isLoading && (
                <>
                    <Styled.Warning>{intl.formatMessage({ id: 'main.Informe sua senha para realizar a alteração de e-mail da plataforma:' })}</Styled.Warning>
                    <Styled.DivText className='last'>
                        <Input
                            id='currentPassword'
                            type='password'
                            placeholder={intl.formatMessage({ id: 'main.Informe sua senha atual' })}
                            {...register('currentPassword')}
                            errors={errors.currentPassword && createError(intl.formatMessage({ id: 'main.Informe sua senha atual corretamente' }))}
                        />
                    </Styled.DivText>
                </>
            )}
        </Modal>
    )
}
